import { Item } from '../types/interfaces';

export const matchingNameMultiselection = (input: Item[], list: Item[]) => {
  return list?.filter((inputVal: Item) => {
    return input?.some((el: Item) => el.id === inputVal.id);
  });
};

export const matchingNameMultiselectionExt = (inputs: Item[], list: { value: number, label?: string }[]) =>
  inputs?.map((input: Item) => {
    const foundObject = list.find((obj: { value: number, label?: string }) => obj.value === input.id)
    return foundObject || { value: input.id, label: input.name }
  });
